var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",style:({
    opacity: _vm.isVisible ? 1 : 0,
    visibility: _vm.isVisible ? 'visible' : 'hidden',
  })},[_c('div',{staticClass:"loader__image"})])
}
var staticRenderFns = []

export { render, staticRenderFns }